import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IApiResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {ITC} from '../../interface/tc'

export class GetTCService extends Request {
  async request(commpanyId: string) {
    try {
      const {data} = await this.client.get<IApiResponse<any>>(`${API_PATH.TC}`, {}).then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateTCService extends Request {
  async request(payload: ITC) {
    try {
      const {data} = await this.client.post<any>(API_PATH.TC, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
